import jexl from 'jexl'
import { Toolbox } from '~/plugins/toolbox/shared'

export const useIfConditions = () => {
  const run = (values: any, conditions: string) => {
    if (Toolbox.Utility.isNull(conditions)) {
      return true
    }

    try {
      const isTrue = jexl.evalSync(conditions, values)

      return isTrue ?? false
    } catch (error) {
      console.error('Unknown Error', error)
      return false
    }
  }

  return {
    run,
  }
}
